<template>
    <div>
        <v-dialog 
            v-model="display"
            persistent
            width="500">
            <v-card flat>
                <v-card-title>
                    {{ $t('user_display') }}
                    <v-spacer></v-spacer>
                    <v-icon v-if="user" large :color="user.inactive ? 'error' : 'success'">
                        {{ user.inactive ? 'mdi-account-cancel' : 'mdi-account-check'  }}
                    </v-icon>
                </v-card-title>
                <div v-if="loading.data" class="text-center">
                    <v-progress-circular
                        indeterminate
                        color="primary">
                    </v-progress-circular>
                </div>
                <v-card-text v-else>
                    <v-simple-table dense v-if="user">
                        <tbody>
                            <tr>
                                <th>{{  $t("name") }}</th>
                                <td>{{user.name}}</td>
                            </tr>
                            <tr>
                                <th>{{ $t("username") }}</th>
                                <td>{{user.username}}</td>
                            </tr>
                            <tr>
                                <th>{{ $t("last_login") }}</th>
                                <td>{{user.last_login}}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    <v-divider></v-divider>
                    <v-autocomplete
                        v-if="authorizations.users.update_roles"
                        class="mt-4"
                        :label="$t('roles_and_permission')"
                        v-model="form.roles"
                        :items="roles"
                        multiple
                        item-text="name"
                        item-value="id"
                        @blur="submit"
                        :loading="loading.roles">
                    </v-autocomplete>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="close" text>{{ $t('close_btn') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <AlertDialog
            ref="alertDialog"/>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import RetryDialog from '@/components/common/RetryDialog';
import AlertDialog from '@/components/common/AlertDialog';
export default {
    name: "UesrDisplayDialog",
    components: {
        RetryDialog,
        AlertDialog
    },
    data() {
        return {
            display: false,
            openParams: null,
            form: {
                user_id: null,
                roles: null
            },
            loading: {
                data: false,
                roles: false
            }, 
        }
    },
    computed: {
        ...mapState('administration/user',["user", "userRole"]),
        ...mapState('administration/role',["roles"]),
        ...mapState('authentication', ["authorizations"])
    },
    methods: {
        ...mapActions('administration/user',["fetchUser", "fetchUserRoles", "updateUserRole"]),
        ...mapActions('administration/role',["fetchRoles"]),
        open(params) {
            this.openParams = params;
            this.loading.data = true;
            this.display = true;
            this.openDataFetch();
        },
        async openDataFetch() {
            try{
                await Promise.all([this.fetchUser(this.openParams.id), this.fetchRoles(), this.fetchUserRoles(this.openParams.id)]);
                this.form.user_id = this.user.id;
                this.form.roles = this.userRole.roles;
                this.loading.data = false; 
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target: "openDataFetch", message});
            }
        },
        submit(){
            this.loading.roles = true;
            this.updateUserRole(this.form)
                .then(() => {
                    this.loading.roles = false;
                    this.$refs.alertDialog.open({type: "success", message: this.$t("record_save_success")})
                })
                .catch(error => {
                    this.loading.roles = false;
                    let message = error.response ? error.response.data.message : error;
                    this.$refs.alertDialog.open({type: "error", message});
                })
        },
        onRetryDialogSubmit(params) {
            if(params.target == "openDataFetch") {
                if(params.retry) this.openDataFetch();
                else this.close();
            }
        },
        resetForm(){
            this.form.user_id = null;
            this.form.roles = null;
        },
        close(){
            Object.assign(this.$data, this.$options.data.apply(this))
        }
        
    }
}
</script>